import debounce from 'lodash/debounce';
import { setMaxHeightStyle } from '../../../scripts/utils/setMaxHeightStyle';

export const initCollapsiblePlugTechSpecsMenu = () => {
  const setMaxHeightToEls = () => {
    setMaxHeightStyle('[data-product-smart-plug-tech-specs-item-content]');
  };

  window.addEventListener('load', setMaxHeightToEls);

  window.addEventListener('resize', debounce(setMaxHeightToEls, 50));
};
